
import { Component, Vue } from 'vue-property-decorator';
import { RouteNames } from '@/router/types';
import AppLogo from './AppLogo.vue';
import AppContact from './AppContact.vue';

@Component({
  components: {
    AppLogo,
    AppContact,
  },
})
export default class AppHeader extends Vue {
  get isCrossroad() {
    return this.$route.name === RouteNames.Crossroad;
  }
}
